import { useState } from "react";

const companies = [
  {
    id: "music",
    icon: "ri-music-2-line",
    name: "뮤직 레이블",
    en: "Music Label",
    description: "아티스트 발굴부터 음원 유통·앨범 제작까지, 케이팝 엔터테인먼트의 전 과정을 운영합니다. 음원 정산, 아티스트 전속 계약, 글로벌 IP 보호가 핵심 업무입니다.",
    roles: ["CEO / 대표이사", "A&R 담당", "재무 담당", "마케팅 담당", "법무 담당"],
    kpis: [
      { label: "음원 스트리밍 수익", unit: "만원/월", icon: "ri-music-line" },
      { label: "아티스트 전속 계약", unit: "팀", icon: "ri-user-star-line" },
      { label: "음반 판매량", unit: "장", icon: "ri-disc-line" },
    ],
    capital: "초기 자본금 5,000만원",
    accent: "#4B6CF7",
    img: "https://public.readdy.ai/ai/img_res/e80a45afa354e8fd946902e0dcfd0160.jpg",
  },
  {
    id: "live",
    icon: "ri-mic-line",
    name: "공연기획사",
    en: "Live Entertainment",
    description: "대형 콘서트와 페스티벌 기획·운영을 담당합니다. 아티스트 섭외부터 티켓 판매 전략, 스폰서 협찬 유치, 무대 제작 예산 집행까지 라이브 비즈니스 전체를 경험합니다.",
    roles: ["대표이사", "공연기획 PD", "티켓영업 MD", "마케팅팀장", "재무담당"],
    kpis: [
      { label: "객석 점유율", unit: "%", icon: "ri-seat-line" },
      { label: "티켓 판매 수익", unit: "만원", icon: "ri-ticket-line" },
      { label: "스폰서 유치 금액", unit: "만원", icon: "ri-shake-hands-line" },
    ],
    capital: "초기 자본금 5,000만원",
    accent: "#7C3AED",
    img: "https://readdy.ai/api/search-image?query=dark%20concert%20stage%20with%20dramatic%20spotlights%20smoke%20effect%20empty%20arena%20professional%20event%20production%20cinematic%20moody%20atmosphere&width=600&height=400&seq=company002&orientation=landscape",
  },
  {
    id: "foundation",
    icon: "ri-community-line",
    name: "문화재단",
    en: "Cultural Foundation",
    description: "정부 보조금과 기부금으로 문화예술 지원 사업을 운영하는 비영리 법인입니다. 보조금 수주 경쟁, 후원자 CRM, 비영리 전표 회계가 핵심입니다.",
    roles: ["사무국장", "사업팀장", "후원개발팀", "회계담당", "사업평가위원"],
    kpis: [
      { label: "보조금 수주액", unit: "만원", icon: "ri-government-line" },
      { label: "사업 수혜자 수", unit: "명", icon: "ri-group-line" },
      { label: "사회공헌 지수", unit: "점", icon: "ri-heart-line" },
    ],
    capital: "정부 보조금 기반 (비영리)",
    accent: "#059669",
    img: "https://readdy.ai/api/search-image?query=dark%20elegant%20art%20gallery%20museum%20interior%20minimalist%20design%20dramatic%20lighting%20cultural%20institution%20modern%20architecture&width=600&height=400&seq=company003&orientation=landscape",
  },
  {
    id: "webtoon",
    icon: "ri-quill-pen-line",
    name: "웹툰 / IP 스튜디오",
    en: "Webtoon & IP Studio",
    description: "웹툰 원작 IP를 개발하고 드라마·게임·굿즈로 2차 판권 수익을 창출합니다. 연재 플랫폼 MOU 계약, 해외 판권 수출 협상, 저작권 등록이 핵심 업무입니다.",
    roles: ["대표이사", "에디터", "계약 MD", "마케터", "법무담당"],
    kpis: [
      { label: "연재 작품 수", unit: "개", icon: "ri-book-2-line" },
      { label: "플랫폼 MOU 수", unit: "개", icon: "ri-links-line" },
      { label: "해외 판권 매출", unit: "만원", icon: "ri-global-line" },
    ],
    capital: "초기 자본금 5,000만원",
    accent: "#D97706",
    img: "https://readdy.ai/api/search-image?query=dark%20creative%20design%20studio%20workspace%20digital%20illustration%20tablets%20screens%20artistic%20environment%20moody%20lighting%20modern%20creative%20office&width=600&height=400&seq=company004&orientation=landscape",
  },
  {
    id: "agency",
    icon: "ri-video-line",
    name: "광고·콘텐츠 에이전시",
    en: "Content & Ad Agency",
    description: "브랜드 광고 캠페인과 뮤직비디오, SNS 콘텐츠를 기획·제작·운영합니다. 클라이언트 제안서 발표, MV 납품 관리, 캠페인 성과 데이터 분석이 핵심 업무입니다.",
    roles: ["대표이사", "크리에이티브 디렉터", "영업 AE", "영상 PD", "데이터 분석가"],
    kpis: [
      { label: "수주 캠페인 수", unit: "건", icon: "ri-advertisement-line" },
      { label: "평균 전환율", unit: "%", icon: "ri-bar-chart-line" },
      { label: "클라이언트 만족도", unit: "점", icon: "ri-star-line" },
    ],
    capital: "초기 자본금 5,000만원",
    accent: "#E11D48",
    img: "https://readdy.ai/api/search-image?query=dark%20modern%20advertising%20agency%20creative%20office%20with%20screens%20monitors%20displaying%20campaign%20work%20professional%20creative%20studio%20cinematic%20moody&width=600&height=400&seq=company005&orientation=landscape",
  },
];

const PD = "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, sans-serif";

export default function CompanyTypesSection() {
  const [active, setActive] = useState(0);
  const current = companies[active];

  return (
    <section id="company-types" className="bg-[#F9F9F9] py-16 md:py-24 lg:py-32" style={{ fontFamily: PD }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <div
            className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-widest mb-4 px-3 py-1.5 rounded-full border"
            style={{ color: current.accent, backgroundColor: `${current.accent}10`, borderColor: `${current.accent}25` }}
          >
            <i className="ri-building-4-line text-xs"></i> Company Types
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4 leading-snug" style={{ fontFamily: PD }}>
            5가지 문화예술 기업 유형
          </h2>
          <p className="text-[#888888] text-base max-w-xl mx-auto">
            각 기업 유형마다 전용 업무 허브, 고유 KPI 지표, 5가지 직무 역할이 제공됩니다.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
          {/* Left: Tab List */}
          <div className="space-y-2">
            {companies.map((co, i) => {
              const isActive = active === i;
              return (
                <button
                  key={co.id}
                  type="button"
                  onClick={() => setActive(i)}
                  className={`w-full flex items-center gap-4 rounded-xl border text-left transition-all cursor-pointer overflow-hidden ${
                    isActive
                      ? "bg-white shadow-sm"
                      : "bg-white border-black/[0.08] hover:border-black/[0.14]"
                  }`}
                  style={isActive ? { borderColor: `${co.accent}40` } : {}}
                >
                  {/* Thumbnail Image */}
                  <div className="w-20 h-16 shrink-0 overflow-hidden relative">
                    <img src={co.img} alt={co.name} className="w-full h-full object-cover object-center" />
                    <div
                      className="absolute inset-0 transition-all"
                      style={{ backgroundColor: isActive ? `${co.accent}30` : "rgba(0,0,0,0.35)" }}
                    />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <i
                        className={`${co.icon} text-base`}
                        style={{ color: isActive ? "#ffffff" : "rgba(255,255,255,0.55)" }}
                      ></i>
                    </div>
                  </div>

                  <div className="flex-1 min-w-0 py-3 pr-4">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span
                        className="text-sm font-semibold transition-colors"
                        style={{ fontFamily: PD, color: isActive ? co.accent : "#555555" }}
                      >
                        {co.name}
                      </span>
                      <span className="text-[10px] text-[#BBBBBB] uppercase tracking-widest">{co.en}</span>
                    </div>
                    {isActive && (
                      <div className="flex flex-wrap gap-1 mt-1.5">
                        {co.roles.map((r) => (
                          <span
                            key={r}
                            className="text-[9px] px-1.5 py-0.5 rounded border"
                            style={{ color: co.accent, backgroundColor: `${co.accent}09`, borderColor: `${co.accent}25` }}
                          >
                            {r}
                          </span>
                        ))}
                      </div>
                    )}
                    {!isActive && (
                      <p className="text-[10px] text-[#BBBBBB] mt-0.5 truncate">{co.description.slice(0, 32)}…</p>
                    )}
                  </div>
                  {isActive && (
                    <i className="ri-arrow-right-s-line text-lg shrink-0 mr-3" style={{ color: co.accent }}></i>
                  )}
                </button>
              );
            })}
          </div>

          {/* Right: Preview Card */}
          <div className="bg-white border border-black/[0.08] rounded-2xl overflow-hidden lg:sticky lg:top-24 shadow-sm">
            {/* Image */}
            <div className="relative h-52 md:h-56 overflow-hidden">
              <img src={current.img} alt={current.name} className="w-full h-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-white via-white/10 to-transparent" />
              <div className="absolute bottom-4 left-5 flex items-center gap-2.5">
                <div
                  className="w-9 h-9 flex items-center justify-center rounded-xl border"
                  style={{ backgroundColor: `${current.accent}20`, borderColor: `${current.accent}30` }}
                >
                  <i className={`${current.icon} text-base`} style={{ color: current.accent }}></i>
                </div>
                <div>
                  <div className="text-[#111111] font-semibold text-sm" style={{ textShadow: "0 0 8px rgba(255,255,255,0.8)" }}>{current.name}</div>
                  <div className="text-[#888888] text-[10px]">{current.en}</div>
                </div>
              </div>
              {/* Capital Badge */}
              <div className="absolute top-4 right-4 bg-white/90 border border-black/[0.09] text-[#666666] text-[10px] px-2.5 py-1 rounded-full">
                {current.capital}
              </div>
            </div>

            <div className="p-5 space-y-4">
              {/* Description */}
              <p className="text-[#666666] text-sm leading-relaxed">{current.description}</p>

              {/* KPI Indicators */}
              <div className="border-t border-black/[0.06] pt-4">
                <p className="text-[#BBBBBB] text-[9px] uppercase tracking-widest mb-3">핵심 KPI 지표</p>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                  {current.kpis.map((kpi) => (
                    <div
                      key={kpi.label}
                      className="bg-[#F9F9F9] border border-black/[0.06] rounded-xl p-3 text-center"
                    >
                      <div className="w-6 h-6 flex items-center justify-center mx-auto mb-1.5">
                        <i className={`${kpi.icon} text-sm`} style={{ color: current.accent }}></i>
                      </div>
                      <p className="text-[#666666] text-[9px] leading-tight mb-0.5">{kpi.label}</p>
                      <p className="text-[#BBBBBB] text-[9px] uppercase tracking-wide">{kpi.unit}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Roles */}
              <div className="border-t border-black/[0.06] pt-4">
                <p className="text-[#BBBBBB] text-[9px] uppercase tracking-widest mb-2.5">직무 구성 (5개 역할)</p>
                <div className="flex flex-wrap gap-1.5">
                  {current.roles.map((r, idx) => (
                    <span
                      key={r}
                      className="text-xs px-2.5 py-1 rounded-lg border"
                      style={
                        idx === 0
                          ? { color: current.accent, backgroundColor: `${current.accent}09`, borderColor: `${current.accent}25` }
                          : { color: "#666666", backgroundColor: "#F5F5F5", borderColor: "rgba(0,0,0,0.08)" }
                      }
                    >
                      {r}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
